import {
  getAudioVolume,
  adjustAudioVolume,
  resizeCaptionSize,
  getNumericCssVarsValues,
  adjustFontSizePercentage
} from '../../mixins/PlayerHelper';

export default {
  togglePlaySound({ commit, state }, audioObj = {}) {
    if (state.soundPlaying) audioObj.pause();
    else audioObj.play();
    commit('playPauseSound', !state.soundPlaying);
  },
  stopSound({ commit }, audioObj = {}) {
    audioObj.stop();
    commit('playPauseSound', false);
    commit('stopSound', true);
  },
  toggleMute({ commit, state }, audioObj = {}) {
    audioObj.mute(!state.soundMuted);
    commit('muteSound', !state.soundMuted);
  },
  toggleCaption({ commit, state }) {
    commit('setShowCaption', !state.showCaption);
  },
  toggleAnimations({ commit, state }) {
    commit('setAnimationsMode', !state.animationsOn);
    const { currentTweenIndex, onGoingAnimation } = state;

    if (state.animationsOn) {
      onGoingAnimation && onGoingAnimation.play();
    } else {
      onGoingAnimation && onGoingAnimation.addPause(2.1 * currentTweenIndex);
    }
  },
  setVolume({ commit }, { audioObj = {}, step = 0.1 }) {
    adjustAudioVolume(audioObj, step);
    const newVolume = getAudioVolume(audioObj);
    commit('setSoundVolume', newVolume);
  },
  resizeCaptionFontSize({ commit }, { captionElement, increment }) {
    resizeCaptionSize(captionElement, increment);
    const newFontSize = getNumericCssVarsValues(captionElement);
    commit('setCaptionFontSize', newFontSize);
  },
  setFontSizePercentage({ commit, state }, increment) {
    const percentage = adjustFontSizePercentage(state.captionSizePercentage, increment);
    commit('setCaptionFontSizePercentage', percentage);
  }
};
